import React from 'react';
import Styles from './LinksMenuItem.module.scss';
import caretRight from '../../../assets/images/icons/caret-right.svg';

const LinksMenuItem = (props) => {
  return (
    <div
      className={`${Styles.linkMenuItem} ${
        props.isActive ? Styles.active : ''
      }`}
      onClick={props.onClick}
    >
      <div className={Styles.itemText}>{props.label}</div>
      <img src={caretRight} />
    </div>
  );
};

export default LinksMenuItem;
